export default __webpack_public_path__ + "static/media/Tim Sandaele.1d547b5a.jpg";